import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "39b70f53-58b3-4d3b-a729-9e1293141955",
  solutionType: "custom012100",
  type: "custom012100",
  options: {
    targetPointLocation: [2, 2],
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "custom012100",
  data: {
    indexes: [
      [0, 0],
      [0, 2],
      [2, 0],
      [2, 2],
    ],
  },
};
